module.exports = __webpack_public_path__ + "img/bobas_bobocoin.gm.6016280.png";